export default __webpack_public_path__ + "media/images/react_icons/remote-doorman-35a185e4635679f30c264a9068c8a0f2.svg";